(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (rotator) => {
      if (!rotator || rotator.dataset.mshqInitialized === 'true') return;
      const messages = Array.from(rotator.querySelectorAll('.mshq-announcement-rotator__message'));
      if (messages.length < 2 || rotator.dataset.autoplay !== 'true') return;

      rotator.dataset.mshqInitialized = 'true';
      let activeIndex = 0;
      const show = (nextIndex) => {
        messages[activeIndex].classList.remove('is-active');
        messages[activeIndex].setAttribute('aria-hidden', 'true');
        activeIndex = nextIndex;
        messages[activeIndex].classList.add('is-active');
        messages[activeIndex].setAttribute('aria-hidden', 'false');
      };
      const interval = Math.max(Number(rotator.dataset.interval) || 5000, 3000);
      window.setInterval(() => show((activeIndex + 1) % messages.length), interval);
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-mshq-announcement-rotator]').forEach(initialize);
    document.addEventListener('DOMContentLoaded', () => initializeAll());
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mshq-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGallery = (section) => {
      if (!section || section.dataset.mshqGalleryInitialized === 'true') return;

      const viewport = section.querySelector('[data-mshq-gallery-viewport]');
      const track = section.querySelector('[data-mshq-gallery-track]');
      const firstSet = section.querySelector('[data-mshq-gallery-set]');
      if (!viewport || !track || !firstSet || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      return;

      section.dataset.mshqGalleryInitialized = 'true';
      let offset = 0;
      let previousTime = 0;
      let isPaused = false;
      let isDragging = false;
      let dragStartX = 0;
      let dragStartOffset = 0;
      let moved = false;
      const speed = 18;

      const setWidth = () => firstSet.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      const normalizeOffset = () => {
        const width = setWidth();
        if (!width) return;
        offset = ((offset % width) + width) % width;
      };
      const render = () => { track.style.transform = `translate3d(${-offset}px, 0, 0)`; };
      const tick = (time) => {
        if (previousTime && !isPaused && !isDragging) {
          offset += ((time - previousTime) / 1000) * speed;
          normalizeOffset();
          render();
        }
        previousTime = time;
        window.requestAnimationFrame(tick);
      };

      viewport.addEventListener('mouseenter', () => { isPaused = true; });
      viewport.addEventListener('mouseleave', () => { if (!isDragging) isPaused = false; });
      viewport.addEventListener('focusin', () => { isPaused = true; });
      viewport.addEventListener('focusout', () => { isPaused = false; });
      viewport.addEventListener('pointerdown', (event) => {
        isDragging = true;
        moved = false;
        dragStartX = event.clientX;
        dragStartOffset = offset;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 4) moved = true;
        offset = dragStartOffset - distance;
        normalizeOffset();
        render();
      });
      const finishDrag = (event) => {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('is-dragging');
        if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      };
      viewport.addEventListener('pointerup', finishDrag);
      viewport.addEventListener('pointercancel', finishDrag);
      viewport.addEventListener('click', (event) => { if (moved) event.preventDefault(); }, true);
      window.addEventListener('resize', () => { normalizeOffset(); render(); });
      window.requestAnimationFrame(tick);
    };

    const initializeAllGalleries = (root = document) => root.querySelectorAll('[data-mshq-gallery-section]').forEach(initializeGallery);
    document.addEventListener('DOMContentLoaded', () => initializeAllGalleries());
    document.addEventListener('shopify:section:load', (event) => initializeAllGalleries(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mshq-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (marquee) => {
      if (marquee.dataset.mshqMarqueeBound === 'true') return;
      marquee.dataset.mshqMarqueeBound = 'true';
      const track = marquee.querySelector('[data-mshq-marquee-track]');
      const groups = [...marquee.querySelectorAll('[data-mshq-marquee-group]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!track || groups.length !== 2) return;
      let animation;
      let resizeFrame;
      const rebuild = () => {
        if (animation) animation.cancel();
        track.style.transform = 'translate3d(0, 0, 0)';
        const minimumWidth = marquee.clientWidth * 1.5;
        groups.forEach((group) => {
          const seed = group.querySelector('[data-mshq-marquee-seed]');
          if (!seed) return;
          group.replaceChildren(seed);
          while (group.scrollWidth < minimumWidth) group.appendChild(seed.cloneNode(true));
        });
        const distance = groups[0].getBoundingClientRect().width;
        if (reduceMotion.matches || distance <= 0 || typeof track.animate !== 'function') return;
        animation = track.animate(
          [
            { transform: 'translate3d(0, 0, 0)' },
            { transform: `translate3d(-${distance}px, 0, 0)` }
          ],
          { duration: Math.max(12000, distance / 70 * 1000), iterations: Infinity, easing: 'linear' }
        );
      };
      const scheduleRebuild = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(rebuild);
      };
      new ResizeObserver(scheduleRebuild).observe(marquee);
      reduceMotion.addEventListener('change', scheduleRebuild);
      scheduleRebuild();
    };
    const init = () => document.querySelectorAll('[data-mshq-marquee]').forEach(bind);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mshq-theme-shell"]) return;
  try {
    
  (() => {
    const root = window.Shopify?.routes?.root || '/';
    const escapeText = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
    const money = (cents) => {
      if (document.documentElement.lang === 'ar') {
        const amount = Number(cents || 0) / 100;
        return `${new Intl.NumberFormat('ar-QA-u-nu-arab', {
          useGrouping: false,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(amount).replace(/٫/g, ',')} ر.ق`;
      }
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
      return `${(Number(cents || 0) / 100).toFixed(2)} QAR`;
    };
    const translateTitle = (title) => {
      if (document.documentElement.lang !== 'en') return title;
      return String(title || '')
        .replace(/برواز خط عربي/g, 'Arabic Calligraphy Frame')
        .replace(/حامل الأسم/g, 'Name Holder')
        .replace(/جملة أو دعاء بالرخام/g, 'Marble Phrase or Supplication')
        .replace(/قاعدة رخامية للعطور والمجوهرات/g, 'Marble Base for Perfumes & Jewelry')
        .replace(/مرآة بقاعدة رخامية/g, 'Mirror with Marble Base')
        .replace(/عمل فني مخصص/g, 'Custom Artwork');
    };
    const productCard = (product) => {
      const image = product.featured_image || product.images?.[0] || '';
      const displayTitle = translateTitle(product.title);
      return `<a class="mshq-client-card" href="${root}products/${encodeURIComponent(product.handle)}"><span class="mshq-client-card__media">${image ? `<img src="${escapeText(image)}" alt="${escapeText(displayTitle)}" loading="lazy" width="720" height="720">` : ''}</span><h3 class="mshq-client-card__title">${escapeText(displayTitle)}</h3><span class="mshq-client-card__price">${money(product.price)}</span></a>`;
    };
    const fetchProduct = async (handle) => {
      const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    };
    const renderRecent = async () => {
      const grid = document.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;
      const current = grid.dataset.currentHandle;
      const handles = (() => {
        try { return JSON.parse(localStorage.getItem('mshq-recent') || '[]'); } catch { return []; }
      })().filter((handle) => handle !== current).slice(0, 3);
      if (!handles.length) {
        grid.closest('[data-recently-viewed-section]')?.setAttribute('hidden', '');
        return;
      }
      const products = (await Promise.all(handles.map((handle) => fetchProduct(handle).catch(() => null)))).filter(Boolean);
      if (products.length) {
        grid.innerHTML = products.map(productCard).join('');
        grid.closest('[data-recently-viewed-section]')?.removeAttribute('hidden');
      }
    };
    const rememberCurrent = () => {
      const current = document.querySelector('[data-product-handle-current]')?.dataset.productHandleCurrent;
      if (!current) return;
      let items = [];
      try { items = JSON.parse(localStorage.getItem('mshq-recent') || '[]'); } catch { items = []; }
      localStorage.setItem('mshq-recent', JSON.stringify([current, ...items.filter((item) => item !== current)].slice(0, 6)));
    };
    const initReveal = () => {
      const elements = document.querySelectorAll('[data-mshq-reveal]');
      if (!('IntersectionObserver' in window)) {
        document.documentElement.classList.remove('mshq-reveal-ready');
        elements.forEach((element) => element.classList.add('is-visible'));
        return;
      }
      document.documentElement.classList.add('mshq-reveal-ready');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { rootMargin: '0px 0px -80px 0px', threshold: 0.12 });
      elements.forEach((element) => {
        if (element.dataset.mshqRevealBound === 'true') return;
        element.dataset.mshqRevealBound = 'true';
        observer.observe(element);
      });
    };
    const initHero = () => {
      const tilt = document.querySelector('[data-mshq-hero-tilt]');
      const hero = tilt?.closest('.mshq-hero');
      if (!tilt || !hero || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const glow = hero.querySelector('.mshq-hero__glow');
      let animationFrame;
      const updateParallax = () => {
        animationFrame = undefined;
        const bounds = hero.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= window.innerHeight || !glow) return;
        const progress = Math.min(Math.max(-bounds.top / bounds.height, 0), 1);
        glow.style.transform = `translateY(${progress * 16}rem) scale(${1 + progress * 0.12})`;
      };
      const requestParallax = () => {
        if (!animationFrame) animationFrame = window.requestAnimationFrame(updateParallax);
      };
      updateParallax();
      window.addEventListener('scroll', requestParallax, { passive: true });
      hero.addEventListener('pointermove', (event) => {
        const bounds = hero.getBoundingClientRect();
        const x = (event.clientX - bounds.left) / bounds.width - 0.5;
        const y = (event.clientY - bounds.top) / bounds.height - 0.5;
        tilt.style.transform = `rotateX(${y * 10}deg) rotateY(${x * -12}deg)`;
      });
      hero.addEventListener('pointerleave', () => { tilt.style.transform = ''; });
    };
    const initHeader = () => {
      const header = document.querySelector('.section-header.shopify-section-group-header-group');
      if (!header || document.body.dataset.template !== 'index') return;
      const update = () => header.classList.toggle('mshq-header-scrolled', window.scrollY > 40);
      update();
      window.addEventListener('scroll', update, { passive: true });
    };
    const changeGiftWrap = async (toggle) => {
      toggle.disabled = true;
      const payload = toggle.checked
        ? { items: [{ id: Number(toggle.dataset.variantId), quantity: 1, properties: { _mshq_gift_wrap: 'true' } }] }
        : { id: toggle.dataset.lineKey, quantity: 0 };
      const endpoint = toggle.checked ? 'cart/add.js' : 'cart/change.js';
      try {
        const response = await fetch(`${root}${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch {
        toggle.checked = !toggle.checked;
        toggle.disabled = false;
      }
    };
    document.addEventListener('change', (event) => {
      const toggleInput = event.target.closest('[data-gift-wrap-toggle]');
      if (toggleInput) changeGiftWrap(toggleInput);
    });
    const initLanguageSwitcher = () => {
      document.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-mshq-lang-switch]');
        if (!btn) return;
        if (btn.classList.contains('is-active')) return;
        event.preventDefault();
        const targetLocale = btn.dataset.mshqLangSwitch;
        const form = btn.closest('form');
        if (form) {
          const input = form.querySelector('input[name="locale_code"]');
          if (input) input.value = targetLocale;
          form.submit();
        }
      });
    };
    const init = () => {
      document.documentElement.dir = document.documentElement.lang.toLowerCase().startsWith('ar') ? 'rtl' : 'ltr';
      rememberCurrent();
      renderRecent();
      initReveal();
      initHero();
      initHeader();
      initLanguageSwitcher();
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
